// extracted by mini-css-extract-plugin
export default {"images":"HotelTable_images__gIk4R"};